const React = require("react");
const { usePrintify } = require("../context/PrintifyContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const SellerPrintifyProducts = () => { const { t } = usePrintify(); return h(ProductCollectionPage, { title: t("h_printify_all_products", "Seller Printify Products"), description: t("h_printify_all_products_desc", "Search, select, preview and import products from your primary Printify shop.") }); };
module.exports = { SellerPrintifyProducts };
